import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

const LABELS = {
  fiscal_issue: "Έκδοση παραστατικού",
  fiscal_cancel: "Ακύρωση παραστατικού",
  fiscal_credit: "Πιστωτικό παραστατικό",
  mydata_settings: "Ρυθμίσεις myDATA",
  boat_delete: "Διαγραφή σκάφους",
  config_save: "Αποθήκευση ρυθμίσεων εγκατάστασης",
};

const fmt = (iso) => {
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const AuditCard = () => {
  const { data = [] } = useQuery({
    queryKey: ["audit"],
    queryFn: async () => (await api.get("/audit", { params: { limit: 50 } })).data,
  });

  return (
    <Card className="rounded-sm border-border shadow-none" data-testid="audit-card">
      <div className="border-b border-border px-6 py-4">
        <h3 className="font-head font-bold">Ιστορικό ενεργειών</h3>
        <p className="mt-1 text-xs text-muted-foreground">Οι τελευταίες 50 κρίσιμες ενέργειες του λογαριασμού (παραστατικά, myDATA, διαγραφές).</p>
      </div>
      {data.length === 0 ? (
        <div className="px-6 py-5 text-sm text-muted-foreground" data-testid="audit-empty">Δεν υπάρχουν καταγεγραμμένες ενέργειες.</div>
      ) : (
        <div className="max-h-80 divide-y divide-border overflow-y-auto">
          {data.map((e) => (
            <div key={e.id} className="flex items-start justify-between gap-3 px-6 py-2.5 text-sm" data-testid={`audit-row-${e.id}`}>
              <div>
                <div className="font-medium">{LABELS[e.action] || e.action}</div>
                {e.detail && <div className="text-xs text-muted-foreground">{e.detail}</div>}
              </div>
              <div className="whitespace-nowrap text-xs text-muted-foreground">{fmt(e.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
